/**
 * checkout.js — trang thanh toán (checkout.html, mục 17 · 24 · 25) bản DEMO.
 *
 * Việc của file:
 *   1. Vẽ danh sách thu gọn + bảng tiền từ WBStore; giỏ rỗng thì hiện empty state thay form.
 *   2. Tính tiền trực tiếp: phí giao theo phương thức (tiêu chuẩn miễn phí khi tạm tính
 *      ≥ WBOrder.FREE_SHIP, hỏa tốc 60.000₫, nhận tại cửa hàng 0₫) + gói quà + mã giảm giá.
 *   3. Khung giờ giao: 7 ngày tính từ HÔM NAY (ngày thật của máy khách), khung 2 tiếng.
 *      Luật ghép với phương thức giao:
 *        - Hỏa tốc 2h chỉ có trong ngày và chỉ ở khung có nhãn ⚡2H → các ngày/khung khác khoá.
 *        - Giao tiêu chuẩn mà bấm khung ⚡2H → tự chuyển sang hỏa tốc (đúng như mục 24: chọn
 *          khung hỏa tốc thì dòng tóm tắt báo phí "Hỏa tốc · 60.000₫").
 *        - Tỉnh/thành ngoài Hà Nội, TP.HCM → khoá hỏa tốc.
 *   4. Kiểm tra form bằng ràng buộc của trình duyệt (required, type=email) + số điện thoại
 *      Việt Nam qua setCustomValidity, lỗi in dưới từng ô (.field--error) thay cho bong bóng
 *      mặc định. Form KHÔNG để novalidate: dữ liệu sai thì sự kiện submit không bắn, nên
 *      form-loading.js (nghe submit để quay vòng nút) không bao giờ kẹt ở trạng thái "đang gửi".
 *   5. Hợp lệ → lưu đơn vào localStorage `wb_last_order`, xoá giỏ + mã giảm giá đã dùng,
 *      chuyển sang order-success.html.
 *
 * Markup cần: [data-checkout-page] chứa form[data-checkout-form], [data-checkout-items],
 * [data-checkout-empty], [data-slots] (dải [data-slot-days] + lưới [data-slot-grid]),
 * input name="shipping_method[0]" / "gift_wrap" / "payment_method", [data-total="…"].
 *
 * WP/WooCommerce: XOÁ file này. Bảng tiền do review-order.php in lại qua AJAX
 * update_order_review (checkout.js của WooCommerce), đặt hàng là POST thật tới
 * ?wc-ajax=checkout. Chỉ giữ lại phần khung giờ (đổi sang đọc ngày/chỗ trống PHP in sẵn)
 * và phần in lỗi dưới ô nếu muốn thay notice mặc định.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var page = document.querySelector('[data-checkout-page]');
    if (!page) return;

    var KEY_ORDER = 'wb_last_order';
    var EXPRESS_FEE = 60000;
    var EXPRESS_PROVINCES = ['Hà Nội', 'TP. Hồ Chí Minh'];
    var PICKUP_ADDRESS = 'WINEBOSS 12 Lý Thái Tổ, Hoàn Kiếm, Hà Nội';
    var DOW = ['Chủ nhật', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'];
    var SLOTS = ['08:00 – 10:00', '10:00 – 12:00', '12:00 – 14:00', '14:00 – 16:00', '16:00 – 18:00', '18:00 – 20:00', '20:00 – 22:00'];
    var FAST_SLOTS = [4, 5]; // 16–18 và 18–20 hôm nay: còn kịp giao trong 2 giờ
    var NOTES = ['Còn chỗ', 'Sắp kín', 'Kín chỗ'];
    // Số đuôi thẻ in ở trang cảm ơn — bản demo không có ô nhập thẻ nên lấy số mẫu của guideline
    var DEMO_CARD = '4821';
    // Trạng thái thanh toán hiện ở trang cảm ơn, theo từng cổng
    var PAY_STATUS = { cod: 'trả khi nhận hàng', card: 'đã thanh toán', qr: 'đã thanh toán', bacs: 'chờ chuyển khoản' };

    var form = page.querySelector('[data-checkout-form]');
    var emptyBox = page.querySelector('[data-checkout-empty]');
    var itemsList = page.querySelector('[data-checkout-items]');
    var dayBox = page.querySelector('[data-slot-days]');
    var slotBox = page.querySelector('[data-slot-grid]');
    var days = [];

    function store() {
        return window.WBStore;
    }

    function order() {
        return window.WBOrder;
    }

    function money(value) {
        return store().money(value);
    }

    function esc(value) {
        return order().esc(value);
    }

    function $(selector, root) {
        return (root || page).querySelector(selector);
    }

    function $$(selector, root) {
        return [].slice.call((root || page).querySelectorAll(selector));
    }

    function checked(name) {
        return form.querySelector('input[name="' + name + '"]:checked');
    }

    function pad(n) {
        return (n < 10 ? '0' : '') + n;
    }

    function isoDate(d) {
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }

    // ===================== Ngày & khung giờ =====================
    // Tình trạng chỗ: 0 còn chỗ · 1 sắp kín · 2 kín chỗ. Bản tĩnh dùng bảng cố định (hôm nay
    // đúng như mục 24, cuối tuần đông hơn ngày thường) để ảnh chụp lần nào cũng giống nhau.
    function availability(index, date) {
        if (index === 0) return [0, 2, 0, 1, 0, 0, 2];
        var weekend = date.getDay() === 0 || date.getDay() === 6;
        return weekend ? [0, 1, 0, 0, 0, 2, 1] : [0, 0, 0, 0, 1, 0, 0];
    }

    function buildDays() {
        var now = new Date();
        var html = '<legend class="screen-reader-text">Ngày giao</legend>';
        days = [];
        for (var i = 0; i < 7; i++) {
            var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + i);
            var day = {
                date: d,
                iso: isoDate(d),
                dow: i === 0 ? 'Hôm nay' : DOW[d.getDay()],
                label: pad(d.getDate()) + '/' + pad(d.getMonth() + 1)
            };
            days.push(day);
            html += '<label class="slot-day"><input class="slot-day__input" type="radio" name="delivery_date" value="' + day.iso + '"' + (i === 0 ? ' checked' : '') + ' />' +
                '<span class="slot-day__dow">' + day.dow + '</span><span class="slot-day__date">' + day.label + '</span></label>';
        }
        dayBox.innerHTML = html;
    }

    // Lưới khung giờ vẽ MỘT lần; đổi ngày / phương thức chỉ cập nhật tại chỗ (disabled, nhãn)
    // để không mất focus khi khách đi bằng phím mũi tên trong nhóm radio.
    function buildSlots() {
        var html = '<legend class="screen-reader-text">Khung giờ (2 tiếng)</legend>';
        SLOTS.forEach(function (time, i) {
            html += '<label class="slot"><input class="slot__input" type="radio" name="delivery_slot" value="' + time + '"' + (i === 2 ? ' checked' : '') + ' />' +
                '<span class="slot__time">' + time + '</span><span class="slot__note"></span>' +
                '<span class="slot__fast" hidden><i class="ph-fill ph-lightning" aria-hidden="true"></i>2H<span class="screen-reader-text"> · giao hỏa tốc</span></span></label>';
        });
        slotBox.innerHTML = html;
    }

    function dayIndex() {
        var input = checked('delivery_date');
        var index = input ? $$('input[name="delivery_date"]', dayBox).indexOf(input) : 0;
        return index < 0 ? 0 : index;
    }

    function method() {
        var input = checked('shipping_method[0]');
        return input ? input.value : 'standard';
    }

    function setMethod(value) {
        var input = form.querySelector('input[name="shipping_method[0]"][value="' + value + '"]');
        if (input && !input.disabled) input.checked = true;
    }

    function isFast(index, slot) {
        return index === 0 && FAST_SLOTS.indexOf(slot) > -1 && method() !== 'pickup';
    }

    function applySlotRules() {
        var express = method() === 'express';
        var dayInputs = $$('input[name="delivery_date"]', dayBox);
        dayInputs.forEach(function (input, i) {
            input.disabled = express && i !== 0;
        });
        if (express && dayIndex() !== 0) dayInputs[0].checked = true;

        var index = dayIndex();
        var avail = availability(index, days[index] ? days[index].date : new Date());
        var slotInputs = $$('input[name="delivery_slot"]', slotBox);

        slotInputs.forEach(function (input, i) {
            var label = input.parentNode;
            var fast = isFast(index, i);
            input.disabled = avail[i] === 2 || (express && !fast);
            if (fast) input.setAttribute('data-fast', '');
            else input.removeAttribute('data-fast');
            $('.slot__note', label).textContent = NOTES[avail[i]];
            $('.slot__fast', label).hidden = !fast;
        });

        // Khung đang chọn không còn hợp lệ → chọn khung đầu tiên còn bấm được.
        // Rời hỏa tốc thì cũng bỏ khung ⚡ — giữ lại thì bấm vào nó lại nhảy về hỏa tốc.
        var current = checked('delivery_slot');
        var invalid = !current || current.disabled || (!express && current.hasAttribute('data-fast'));
        if (invalid) {
            var next = slotInputs.filter(function (input) {
                return !input.disabled && (express || !input.hasAttribute('data-fast'));
            })[0];
            if (current) current.checked = false;
            if (next) next.checked = true;
        }
    }

    // ===================== Tiền =====================
    function shippingFee(subtotal) {
        var m = method();
        if (m === 'express') return EXPRESS_FEE;
        if (m === 'pickup') return 0;
        return order().standardFee(subtotal);
    }

    function totals() {
        var subtotal = store().cart.subtotal();
        var discount = order().discount(subtotal);
        var ship = shippingFee(subtotal);
        var gift = checked('gift_wrap');
        var giftFee = gift ? Number(gift.getAttribute('data-fee')) || 0 : 0;
        return {
            subtotal: subtotal,
            discount: discount,
            shipping: ship,
            gift: giftFee,
            total: Math.max(0, subtotal - discount + ship + giftFee)
        };
    }

    function setText(selector, value) {
        $$(selector).forEach(function (el) {
            el.textContent = value;
        });
    }

    function renderItems() {
        var items = store().cart.items();
        itemsList.innerHTML = items.map(function (item) {
            return '<li class="checkout-item cart_item">' +
                '<span class="thumb"><img src="' + esc(item.image) + '" alt="" width="600" height="800" /></span>' +
                '<span class="checkout-item__info"><span class="checkout-item__name">' + esc(item.name) + (item.year ? ' ' + esc(item.year) : '') + (item.variant ? ' · ' + esc(item.variant) : '') + '</span>' +
                '<span class="checkout-item__meta">' + item.qty + ' × ' + money(item.price) + '</span></span>' +
                '<span class="checkout-item__total">' + money(item.price * item.qty) + '</span></li>';
        }).join('');
        setText('[data-checkout-count]', '(' + store().cart.count() + ' sản phẩm)');
    }

    function slotText() {
        var index = dayIndex();
        var day = days[index];
        var slot = checked('delivery_slot');
        if (!day) return '';
        return (index === 0 ? 'hôm nay' : day.dow.toLowerCase()) + ' ' + day.label + (slot ? ' · ' + slot.value : '');
    }

    function render() {
        var t = totals();
        var m = method();

        setText('[data-total="subtotal"]', money(t.subtotal));
        setText('[data-total="discount"]', '−' + money(t.discount));
        setText('[data-total="shipping"]', t.shipping ? money(t.shipping) : 'Miễn phí');
        setText('[data-total="total"]', money(t.total));
        setText('[data-ship-fee="standard"]', order().standardFee(t.subtotal) ? money(order().standardFee(t.subtotal)) : 'Miễn phí');

        $$('[data-total-row="discount"]').forEach(function (row) {
            row.hidden = !t.discount;
        });

        var gift = checked('gift_wrap');
        var giftRow = $('[data-total-row="gift"]');
        if (giftRow) {
            giftRow.hidden = !gift || gift.value === 'none';
            setText('[data-total="gift-label"]', gift ? 'Gói quà · ' + gift.getAttribute('data-gift-label') : 'Gói quà');
            setText('[data-total="gift"]', t.gift ? money(t.gift) : 'Miễn phí');
        }

        setText('[data-slot-verb]', m === 'pickup' ? 'Nhận tại cửa hàng' : 'Giao');
        setText('[data-slot-summary]', slotText());
        setText('[data-slot-fee]', m === 'express' ? 'Hỏa tốc · ' + money(EXPRESS_FEE) : (t.shipping ? money(t.shipping) : 'Miễn phí'));

        var pay = checked('payment_method');
        setText('[data-pay-note-text]', pay ? pay.getAttribute('data-pay-note') : '');
    }

    // Hỏa tốc chỉ nội thành Hà Nội, TP.HCM: chọn tỉnh khác thì khoá thẻ hỏa tốc
    function applyProvinceRule() {
        var province = $('[data-checkout-province]');
        var express = form.querySelector('input[name="shipping_method[0]"][value="express"]');
        if (!province || !express) return;
        var outside = province.value !== '' && EXPRESS_PROVINCES.indexOf(province.value) === -1;
        express.disabled = outside;
        if (outside && express.checked) setMethod('standard');
    }

    function update() {
        applyProvinceRule();
        applySlotRules();
        render();
    }

    // ===================== Kiểm tra form =====================
    function phoneOk(value) {
        var digits = String(value).replace(/[\s.\-()]/g, '');
        return /^(?:\+?84|0)(?:3|5|7|8|9)\d{8}$/.test(digits);
    }

    function syncPhone(input) {
        input.setCustomValidity(input.value.trim() && !phoneOk(input.value) ? 'Số điện thoại chưa đúng (vd 0901 234 567).' : '');
    }

    function messageFor(input) {
        var v = input.validity;
        if (v.valueMissing) return input.getAttribute('data-msg-required') || 'Vui lòng điền thông tin này.';
        if (v.typeMismatch) return input.getAttribute('data-msg-type') || input.validationMessage;
        return input.validationMessage;
    }

    function showError(input, message) {
        var field = input.closest('.field');
        var error = field ? field.querySelector('.field__error') : null;
        if (field) field.classList.toggle('field--error', !!message);
        if (error) {
            error.hidden = !message;
            error.textContent = message || '';
        }
        if (message) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
    }

    var firstInvalid = null;

    function bindValidation() {
        var phone = form.querySelector('[data-phone-vn]');

        // Sự kiện invalid không nổi bọt → nghe ở pha capture. Huỷ nó để tắt bong bóng mặc định
        // (mỗi trình duyệt một kiểu, lại biến mất sau vài giây) và in lỗi cố định dưới ô.
        form.addEventListener('invalid', function (event) {
            var input = event.target;
            event.preventDefault();
            showError(input, messageFor(input));
            if (!firstInvalid) {
                firstInvalid = input;
                // Huỷ invalid thì trình duyệt cũng thôi tự đưa focus tới ô lỗi — làm thay
                window.setTimeout(function () {
                    if (firstInvalid) firstInvalid.focus();
                    firstInvalid = null;
                }, 0);
            }
        }, true);

        // Đang báo lỗi mà sửa đúng thì gỡ lỗi ngay khi gõ; chưa từng báo thì để yên tới lúc gửi
        form.addEventListener('input', function (event) {
            var input = event.target;
            if (input === phone) syncPhone(input);
            if (input.getAttribute('aria-invalid') === 'true' && input.validity.valid) showError(input, '');
        });

        form.addEventListener('change', function (event) {
            var input = event.target;
            if (input.matches('.field select') && input.validity.valid) showError(input, '');
        });

        // SĐT: kiểm ngay khi rời ô — sai định dạng là lỗi hay gặp nhất, báo sớm đỡ phải sửa lúc cuối
        if (phone) {
            phone.addEventListener('blur', function () {
                syncPhone(phone);
                if (phone.value.trim()) showError(phone, phone.validity.valid ? '' : messageFor(phone));
            });
            syncPhone(phone);
        }
    }

    // ===================== Đặt hàng =====================
    function orderNumber(now) {
        var stamp = now.getFullYear() + pad(now.getMonth() + 1) + pad(now.getDate());
        return 'WB' + stamp + '-' + String(Math.floor(1000 + Math.random() * 9000));
    }

    function value(name) {
        var el = form.elements[name];
        return el ? String(el.value).trim() : '';
    }

    function buildOrder() {
        var now = new Date();
        var t = totals();
        var m = method();
        var ship = checked('shipping_method[0]');
        var gift = checked('gift_wrap');
        var pay = checked('payment_method');
        var slot = checked('delivery_slot');
        var day = days[dayIndex()];
        var payMethod = pay ? pay.value : 'cod';
        var address = [value('billing_address_1'), value('billing_city'), value('billing_state')].filter(Boolean).join(', ');

        return {
            number: orderNumber(now),
            createdAt: now.toISOString(),
            customer: { name: value('billing_first_name'), phone: value('billing_phone'), email: value('billing_email') },
            address: m === 'pickup' ? PICKUP_ADDRESS : address,
            billingAddress: address,
            note: value('order_comments'),
            items: store().cart.items().map(function (item) {
                return {
                    id: item.id,
                    name: item.name,
                    year: item.year || '',
                    variant: item.variant || '',
                    qty: item.qty,
                    price: item.price,
                    image: item.image,
                    url: item.url
                };
            }),
            count: store().cart.count(),
            subtotal: t.subtotal,
            coupon: order().coupon(),
            discount: t.discount,
            shipping: { method: m, label: ship ? ship.getAttribute('data-ship-label') : '', fee: t.shipping },
            delivery: { date: day ? day.iso : isoDate(now), slot: slot ? slot.value : '' },
            gift: { value: gift ? gift.value : 'none', label: gift ? gift.getAttribute('data-gift-label') : '', fee: t.gift },
            payment: {
                method: payMethod,
                label: pay ? pay.getAttribute('data-pay-label') : '',
                card: payMethod === 'card' ? DEMO_CARD : '',
                status: PAY_STATUS[payMethod] || ''
            },
            total: t.total
        };
    }

    function save(data) {
        try {
            window.localStorage.setItem(KEY_ORDER, JSON.stringify(data));
        } catch (e) {
            /* Safari riêng tư: trang cảm ơn sẽ hiện dữ liệu mẫu */
        }
    }

    function bindSubmit() {
        form.addEventListener('submit', function (event) {
            // Bản tĩnh không có server: tự lưu đơn rồi chuyển trang. Nút đã quay vòng nhờ form-loading.js.
            event.preventDefault();
            if (!store().cart.count()) return;
            save(buildOrder());
            store().cart.clear();
            // Mã giảm giá dùng một lần cho một đơn — như WooCommerce gỡ coupon khỏi phiên sau khi đặt
            order().removeCoupon();
            window.setTimeout(function () {
                window.location.href = form.getAttribute('action') || 'order-success.html';
            }, 600);
        });
    }

    // ===================== Khởi động =====================
    function showEmpty(empty) {
        form.hidden = empty;
        if (emptyBox) emptyBox.hidden = !empty;
    }

    function init() {
        if (!store() || !order() || !form) return;

        if (!store().cart.count()) {
            showEmpty(true);
            return;
        }

        buildDays();
        buildSlots();
        renderItems();
        order().bindCoupon($('[data-coupon]'));
        bindValidation();
        bindSubmit();

        form.addEventListener('change', function (event) {
            var input = event.target;
            // Bấm khung ⚡2H khi đang giao tiêu chuẩn → coi như chọn hỏa tốc (mục 24)
            if (input.name === 'delivery_slot' && input.hasAttribute('data-fast') && method() === 'standard') {
                setMethod('express');
            }
            if (/^(shipping_method\[0\]|delivery_date|delivery_slot|gift_wrap|payment_method|billing_state)$/.test(input.name)) {
                update();
            }
        });

        document.addEventListener('wb:coupon', render);
        // Đặt xong bấm Back: trình duyệt trả trang từ bfcache với form cũ trong khi giỏ đã
        // xoá — gửi lại sẽ chẳng ra đơn nào mà nút cứ quay vòng. Chuyển sang trạng thái rỗng.
        window.addEventListener('pageshow', function (event) {
            if (event.persisted && !store().cart.count()) showEmpty(true);
        });
        // Giỏ đổi ở tab khác / mini cart: vẽ lại; giỏ hết hàng thì về trạng thái rỗng.
        // Bỏ qua lần xoá do chính trang này gây ra lúc đặt hàng (đã lưu đơn, đang chuyển trang).
        document.addEventListener('wb:cart', function (event) {
            if (event.detail && event.detail.reason === 'clear') return;
            if (!store().cart.count()) {
                showEmpty(true);
                return;
            }
            renderItems();
            render();
        });

        update();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
